﻿export class RelatedParty {
    Name:string;
    Role: string;
    Attorney:string;
}

export class FutureHearing {
    HearingDateTime:string;
}

export class RelatedPetitions {
    PetitionDate:string;
}

export class CalendarDetail {
    CaseDisplayNumber: string;
    StartDateTime :string;
    EntityName : string;
    Location : string;
    HearingType : string;
    HearingSubType : string;
    RelatedParty: RelatedParty[];
    FutureHearing: FutureHearing[];
    RelatedPetitions: RelatedPetitions[];
}
